// src/data/services.js
// NOTE: i18n-ready: every human text has a parallel t* key.
// Your components can read like: t(item.tHeroKicker, item.hero.kicker)

import eventSecurityHero from "../assets/industries/event-security.jpg";
import eventPic1 from "../assets/industries/event-sec1.jpg";
import eventPic2 from "../assets/industries/event-sec2.jpg";
import eventPic3 from "../assets/industries/event-sec3.jpg";
import dsc3204Pic from "../assets/DSC03204.jpg";
import dsc3245Pic from "../assets/DSC03245.jpg";
import dsc01103Pic from "../assets/DSC01103.JPG";
import visionSecuriteV2Webm from "../assets/vision-securite-v2.webm";
import visionSecuriteV2Mp4 from "../assets/vision-securite-v2.mp4"; // Add MP4 version
import hospitalityPic from "../assets/industries/Hospitalitypic.jpg";

// Carousel images
import carousel1 from "../assets/Carouselcollage/A6703379.jpeg";
import carousel2 from "../assets/Carouselcollage/A6704075.jpeg";
import carousel3 from "../assets/Carouselcollage/DSC00881.JPG";
import carousel4 from "../assets/Carouselcollage/DSC00918.JPG";
import carousel5 from "../assets/Carouselcollage/DSC00924.JPG";
import carousel6 from "../assets/Carouselcollage/DSC00999.JPG";
import carousel7 from "../assets/Carouselcollage/DSC01127.JPG";
import carousel8 from "../assets/Carouselcollage/DSC01142.JPG";
import carousel9 from "../assets/Carouselcollage/DSC01215.JPG";
import carousel10 from "../assets/Carouselcollage/DSC01577.JPG";
import carousel11 from "../assets/Carouselcollage/DSC01580.JPG";
import carousel12 from "../assets/Carouselcollage/DSC01583.JPG";
import carousel13 from "../assets/Carouselcollage/DSC01593.JPG";
import carousel14 from "../assets/Carouselcollage/DSC02437.jpg";
import carousel15 from "../assets/Carouselcollage/DSC02512 (1).jpg";
import carousel16 from "../assets/Carouselcollage/DSC03199 (1).jpg";
import carousel17 from "../assets/Carouselcollage/P1606374.jpeg";
import carousel18 from "../assets/Carouselcollage/P1606394.jpeg";
import carousel19 from "../assets/Carouselcollage/P1606514.jpeg";
import carousel20 from "../assets/Carouselcollage/P1606621.jpeg";
import carousel21 from "../assets/Carouselcollage/P1606797.jpeg";
import carousel22 from "../assets/Carouselcollage/PHOTO-175 (1).JPG";
import carousel23 from "../assets/Carouselcollage/VISION_SECURITY_GCK_EVENT-080.jpg";
import carousel24 from "../assets/Carouselcollage/VISION_SECURITY_GCK_EVENT-131.jpg";
import theLintonPic from "../assets/TheLinton.jpg";
import pic10 from "../assets/10.jpg";
import img6026Pic from "../assets/IMG_6026.jpeg";
import visionReelVideoWebm from "../assets/vision-reel-wide.webm";
import visionReelVideoMp4 from "../assets/vision-reel-wide.mp4"; // Add MP4 version
import luxurySecurityVideoWebm from "../assets/luxury-security-video.webm";
import luxurySecurityVideoMp4 from "../assets/luxury-security-video.mp4"; // Add MP4 version
import securiteGoodnewsPic from "../assets/industries/SecuriteGoodnewspic.jpg";

// residential
import residential_pic1 from "../assets/industries/residential_pic1.JPEG";
import richhoodPic from "../assets/industries/richhood.jpg";
import dsc1813Pic from "../assets/DSC01813.jpg";
import img6841Pic from "../assets/IMG_6841.jpeg";

// business
import business_pic1 from "../assets/industries/business_security1.jpg";
import business_pic2 from "../assets/industries/business_security2.jpg";
import business_pic3 from "../assets/industries/business_security3.jpg";
import torontoPic from "../assets/industries/Torontopic.jpg";

// traffic
import traffic_pic1 from "../assets/industries/traffic_security1.jpg";
import traffic_pic2 from "../assets/industries/traffic_security2.jpg";
import traffic_pic3 from "../assets/industries/traffic_security3.jpg";

// fire
import fire_pic1 from "../assets/industries/fire_security1.jpg";
import fire_pic2 from "../assets/industries/fire_security2.jpg";
import firehousePic from "../assets/industries/firehouse.jpeg";
import dsc1622Pic from "../assets/DSC01622.jpg";

// luxury
import luxury_pic1 from "../assets/industries/luxury_security1.jpg";
import luxury_pic2 from "../assets/industries/luxury_security2.avif";
import luxury_pic3 from "../assets/industries/luxury_security3.jpg";

// VIP
import damsoPic from "../assets/Damso.jpeg";
import nettspendPic from "../assets/Nettspend.jpeg";
import hollisPic from "../assets/2Hollis.jpg";
import vipPic from "../assets/vip.jpg";

// Patrol
import silverUnmarkedPic from "../assets/silver-unmarked.jpg";
import patrolServicesPic from "../assets/industries/patrol_services.jpg";
import patrolBlock2Pic from "../assets/Screenshot_4-11.jpeg";
import patrolBlock3Pic from "../assets/Live-Tracking-features-2.jpg";

// loss
import loss_pic1 from "../assets/industries/loss-security1.jpg";
import loss_pic2 from "../assets/industries/loss-security2.jpg";
import loss_pic3 from "../assets/industries/loss-security3.jpg";
import mallPic from "../assets/mall.jpg";

// intervention
import intervention_pic1 from "../assets/armypic1.jpeg";
import intervention_pic2 from "../assets/chasepic7.jpeg";
import intervention_pic3 from "../assets/maxpic1.jpeg";

// construction
import construction_pic1 from "../assets/industries/construction_pic1.JPEG";
import construction_pic2 from "../assets/industries/construction_pic2.jpg";
import constructionHeroPic from "../assets/whoWeServe/Screenshot_4-11-2025_20119_businessoutstanders.s3.amazonaws.com.jpeg";
import construct1Pic from "../assets/construct1.jpg";
import dsc01642Pic from "../assets/DSC01642.jpg";

/**
 * How to use the i18n keys:
 * In components, prefer the translation with fallback:
 *  const txt = (key, fallback) => t(key, { defaultValue: fallback });
 *  <h1>{txt(service.tHeroTitle0, service.hero.titleLines[0].text)}</h1>
 */

const SERVICES = {
  "event-security": {
    slug: "event-security",
    // ---- i18n keys for hero
    tHeroTitle0: "services.event-security.hero.title0",
    tHeroKicker: "services.event-security.hero.kicker",
    tHeroCta:    "services.event-security.hero.cta",
    hero: {
      bgImage: securiteGoodnewsPic,
      titleLines: [{ text: "Elite Event Security Solutions", accent: "Security" }],
      kicker: "Concerts • Festivals • Corporate Events • Sports Venues • Private Functions",
      
    },
    carouselImages: [
      carousel1, carousel2, carousel3, carousel4, carousel5, carousel6,
      carousel7, carousel8, carousel9, carousel10, carousel11, carousel12,
      carousel13, carousel14, carousel15, carousel16, carousel17, carousel18,
      carousel19, carousel20, carousel21, carousel22, carousel23, carousel24
    ],
    // ---- i18n keys for expertise
    tExpEyebrow: "services.event-security.expertise.eyebrow",
    tExpTitle:   "services.event-security.expertise.title",
    tExpCopy:    "services.event-security.expertise.copy",
    expertise: {
      eyebrow: "Our Specialized Expertise",
      title: "Your trusted event security partner",
      copy:
        "At Vision, we bring unmatched expertise in event security services across Quebec and Ontario. From intimate community gatherings to massive festivals, our team has secured it all. Notably, we managed the pit at Igloofest in the Old Port of Montreal, where a crowd of over 70,000 attendees was handled seamlessly despite staffing challenges. Our success in high-pressure environments demonstrates the depth of our experience and our ability to adapt quickly. With every project, our management team goes above and beyond in the planning stages, ensuring that your event not only meets but exceeds safety expectations.",
    },
    // ---- i18n keys for blocks
    tBlock1Title: "services.event-security.blocks.1.title",
    tBlock1Copy:  "services.event-security.blocks.1.copy",
    tBlock2Title: "services.event-security.blocks.2.title",
    tBlock2Copy0: "services.event-security.blocks.2.copy.0",
    tBlock2Copy1: "services.event-security.blocks.2.copy.1",
    tBlock2Copy2: "services.event-security.blocks.2.copy.2",
    tBlock3Title: "services.event-security.blocks.3.title",
    tBlock3Copy:  "services.event-security.blocks.3.copy",
    blocks: [
      {
        title: "Professional Event Security Guards for Concerts, Corporate Gatherings & Festivals",
        copy:
          "We understand that every event is unique, which is why our solutions are tailored to match the scale and nature of your occasion. Whether you're hosting a concert, corporate gathering, sporting event, or festival, our trained event security agents are prepared to maintain order and provide a safe environment for guests, staff, and performers alike. Our preparation includes detailed risk assessments, crowd-control strategies, and proactive incident prevention, ensuring that all aspects of your event remain secure.",
        image: dsc3204Pic,
        imageAlt: "Officer assisting guests at entrance",
      },
      {
        title: "Trusted Event Security Experts in Québec and Ontario",
        accent: "perimeter",
        icons: ["★", "★", "★", "★", "★"],
        copy: [
          "At Vision Sécurité, we go beyond traditional event security by emphasizing communication, professionalism, and a visible security presence that reassures both guests and organizers. Our experienced event security agents are trained to provide proactive protection and maintain order at concerts, festivals, corporate events, sports venues, and private gatherings of all sizes. We work hand in hand with event organizers, venue managers, and local authorities to ensure seamless coordination before, during, and after every event.",
          "From access control and perimeter patrols to crowd management, VIP protection, and emergency response planning, our personnel are trained to handle high-pressure situations with confidence and discretion. Each agent undergoes continuous training to adapt to dynamic event environments, ensuring that every guest enjoys a safe and welcoming atmosphere.",
          "With proven experience across Québec and Ontario, Vision Sécurité has built a reputation for reliability, responsiveness, and professionalism. Whether securing a large-scale outdoor festival or an intimate corporate gala, our mission is to deliver peace of mind through trusted, professional event security services. When safety and coordination matter most, event organizers across Canada turn to Vision Sécurité as their trusted event security partner."
        ],
        videoSources: [
          { src: visionSecuriteV2Webm, type: "video/webm" },
          { src: visionSecuriteV2Mp4, type: "video/mp4" }
        ],
        imageAlt: "Officer monitoring restricted area",
        flip: true,
      },
      {
        title: "Cutting-Edge Event Security: Technology-Driven Protection for Every Venue",
        copy:
          "Technology and specialized equipment give us an edge in keeping your event safe. Our agents are equipped with high-grade walkie-talkies for clear communication across large venues, and we deploy metal detectors and access-control methods to keep prohibited items out. With our geo-mapping and live agent tracking system, we can monitor deployments in real time and coordinate responses instantly. In emergencies, our in-house software locates the nearest available guard, allowing us to react swiftly and effectively. Combined with 24/7 management support and centralized reporting, Vision Sécurité delivers a seamless security experience that makes us the trusted partner for events of any size.",
        image: dsc3245Pic,
        imageAlt: "Crowd flow management at venue",
      },
    ],
    // ---- i18n keys for footer cta
    tFooterTitle: "services.event-security.footerCta.title",
    tFooterCopy:  "services.event-security.footerCta.copy",
    tFooterLabel: "services.event-security.footerCta.label",
    footerCta: {
      title: "Ready to secure your next event",
      accent: "event",
      copy: "Let’s tailor staffing, posts, and procedures to your site map and schedule.",
      label: "Schedule a consultation",
      href: "/contact",
    },
  },

  // ========================= RESIDENTIAL =========================
  "residential-security": {
    slug: "residential-security",
    tHeroTitle0: "services.residential-security.hero.title0",
    tHeroKicker: "services.residential-security.hero.kicker",
    tHeroCta:    "services.residential-security.hero.cta",
    hero: {
      bgImage: richhoodPic,
      titleLines: [{ text: "Residential Security", accent: "Security" }],
      kicker: "Private homes • Condominiums • Residential communities",
      
      cta: { label: "Talk to an expert", href: "/contact" },
    },
    tExpEyebrow: "services.residential-security.expertise.eyebrow",
    tExpTitle:   "services.residential-security.expertise.title",
    tExpCopy:    "services.residential-security.expertise.copy",
    expertise: {
      eyebrow: "Our expertise",
      title: "We are your residential security partner",
      copy:
        "Every household has different needs, which is why we tailor our services to fit your lifestyle. Whether you require 24/7 on-site protection, neighborhood patrols, or event coverage at your residence, our team adapts to your situation.",
    },
    tBlock1Title: "services.residential-security.blocks.1.title",
    tBlock1Copy:  "services.residential-security.blocks.1.copy",
    tBlock2Title: "services.residential-security.blocks.2.title",
    tBlock2Copy:  "services.residential-security.blocks.2.copy",
    tBlock3Title: "services.residential-security.blocks.3.title",
    tBlock3Copy:  "services.residential-security.blocks.3.copy",
    blocks: [
      {
        title: "Personalized home protection",
        copy:
          "At Vision, keeping your home and family safe is our top priority. Having protected countless residences across Quebec and Ontario, we understand the unique challenges that come with securing private homes, condominiums, and residential communities. Our highly trained residential security agents are equipped to deter theft, prevent intrusions, and provide peace of mind for you and your loved ones. We work closely with local law enforcement when needed, ensuring a comprehensive and reliable safety net for your home.",
        image: residential_pic1,
        imageAlt: "Residential security officer monitoring entrance",
      },
      {
        title: "Visible deterrence & community patrols",
        accent: "deterrence",
        copy:
          "Every household has different needs, which is why we tailor our residential security services to fit your lifestyle. Whether you require 24/7 on-site protection, neighborhood patrols, or special event coverage at your residence, our team adapts to your situation. Our agents undergo specialized residential security training, preparing them for the unique demands of protecting families and private properties. With the added presence of visible deterrence measures such as uniformed guards and marked patrol vehicles, Vision Sécurité ensures that threats are discouraged before they even occur.",
        image: img6841Pic,
        imageAlt: "Marked patrol vehicle in residential neighborhood",
        flip: true,
      },
      {
        title: "Advanced technology & rapid response",
        copy:
          "Our commitment to safety is further enhanced through advanced security technology. Using geo-mapping and live agent tracking, we know exactly where our guards are at all times, ensuring accountability and rapid deployment. Clients gain access to centralized digital reporting and real-time updates, while our system connects you directly with agents and our management team 24/7. In case of emergencies, our in-house software locates the nearest available guard, allowing us to dispatch support to your address with an average emergency response time of under 60 minutes. This seamless combination of professional training, visible deterrence, and advanced technology makes Vision Sécurité the trusted choice for residential protection. To learn more about our expertise in this field, have a look at our blog",
        image: dsc1813Pic,
        imageAlt: "Control room monitoring residential security feeds",
      },
    ],
    tFooterTitle: "services.residential-security.footerCta.title",
    tFooterCopy:  "services.residential-security.footerCta.copy",
    tFooterLabel: "services.residential-security.footerCta.label",
    footerCta: {
      title: "Ready to secure your home",
      accent: "home",
      copy:
        "Discover why homeowners trust Vision Sécurité for comprehensive, responsive, and technology-enhanced protection.",
      label: "Schedule a consultation",
      href: "/contact",
    },
  },

  // ========================= BUSINESS =========================
  "business-security": {
    slug: "business-security",
    tHeroTitle0: "services.business-security.hero.title0",
    tHeroKicker: "services.business-security.hero.kicker",
    tHeroCta:    "services.business-security.hero.cta",
    hero: {
      bgImage: torontoPic,
      titleLines: [{ text: "Business Security Services", accent: "Services" }],
      kicker: "Retail • Offices • Warehouses • Commercial Properties",
     
      cta: { label: "Talk to an expert", href: "/contact" },
    },
    tExpEyebrow: "services.business-security.expertise.eyebrow",
    tExpTitle:   "services.business-security.expertise.title",
    tExpCopy:    "services.business-security.expertise.copy",
    expertise: {
      eyebrow: "Our expertise",
      title: "Professional Business Security Services in Québec & Ontario",
      copy:
        "At Vision, we specialize in protecting businesses of all sizes across Quebec and Ontario. Having secured hundreds of businesses, we understand that every company faces unique challenges when it comes to safety and security. That’s why we provide professional security agents tailored to your specific needs—whether it’s safeguarding retail stores, offices, warehouses, or commercial properties. Our client-first approach ensures that customer service is never compromised. With a proven five-star reputation, our commitment to excellence and reliability speaks for itself.",
    },
    tBlock1Title: "services.business-security.blocks.1.title",
    tBlock1Copy:  "services.business-security.blocks.1.copy",
    tBlock2Title: "services.business-security.blocks.2.title",
    tBlock2Copy:  "services.business-security.blocks.2.copy",
    tBlock3Title: "services.business-security.blocks.3.title",
    tBlock3Copy:  "services.business-security.blocks.3.copy",
    blocks: [
      {
        title: "Expertly Trained Security Agents Adapted to Your Business Needs",
        copy:
          "Our team stands apart thanks to our in-house customer service training program, designed to prepare agents for a wide range of environments. From high-traffic retail centers to sensitive corporate facilities, our workforce has been tested and proven in diverse situations. This flexibility allows us to adapt quickly when clients request changes, ensuring that the right agent is always in place. At Vision, we go above and beyond to provide business security solutions that adapt to you, not the other way around.",
        image: business_pic1,
        imageAlt: "Professional security officer greeting guests at event entrance",
      },
      {
        title: "Real-Time Business Security Monitoring & Rapid Response Technology",
        accent: "VIP",
        copy:
          "Technology plays a central role in delivering reliable protection. We use advanced geo-mapping and tracking systems to monitor agents in real time, manage clock-ins, and send shift reminders. Our centralized reporting platform gives clients direct access to live reports, with 24/7 communication available with both agents and management. In emergencies, our proprietary software instantly locates the closest available agent to your business, allowing us to provide an average emergency response time of under 60 minutes. This integration of human expertise with cutting-edge technology is what makes Vision Sécurité the trusted choice for business security. To learn more about our expertise in this field, have a look at our blog [here](INSERT LINK). <-link to blog post",
        image: business_pic2,
        imageAlt: "Security agent providing VIP protection backstage",
        flip: true,
      },
      {
        title: "Advanced Crowd Management & Emergency Response",
        copy:
          "Technology plays a central role in delivering reliable protection. We use advanced geo-mapping and tracking systems to monitor agents in real time, manage clock-ins, and send shift reminders. Our centralized reporting platform gives clients direct access to live reports, with 24/7 communication available with both agents and management. In emergencies, our proprietary software instantly locates the closest available agent to your business, allowing us to provide an average emergency response time of under 60 minutes. This integration of human expertise with cutting-edge technology is what makes Vision Sécurité the trusted choice for business security. To learn more about our expertise in this field, have a look at our blog",
        image: business_pic3,
        imageAlt: "Security team managing crowd flow at large venue",
      },
    ],
    tFooterTitle: "services.business-security.footerCta.title",
    tFooterCopy:  "services.business-security.footerCta.copy",
    tFooterLabel: "services.business-security.footerCta.label",
    footerCta: {
      title: "Ready to choose vision to secure your business?",
      accent: "event",
      copy:
        "Let’s tailor staffing, posts, and procedures to your site map and schedule.",
      label: "Schedule a consultation",
      href: "/contact",
    },
  },

  // ========================= TRAFFIC =========================
  "traffic-control": {
    slug: "traffic-control",
    tHeroTitle0: "services.traffic-control.hero.title0",
    tHeroKicker: "services.traffic-control.hero.kicker",
    tHeroCta:    "services.traffic-control.hero.cta",
    hero: {
      bgVideoSources: [
        { src: visionReelVideoWebm, type: "video/webm" },
        { src: visionReelVideoMp4, type: "video/mp4" }
      ],
      titleLines: [{ text: "Traffic Control Services", accent: "Services" }],
      kicker: "Parades • Festivals • Road closures • Major events",
     
      cta: { label: "Talk to an expert", href: "/contact" },
    },
    tExpEyebrow: "services.traffic-control.expertise.eyebrow",
    tExpTitle:   "services.traffic-control.expertise.title",
    tExpCopy:    "services.traffic-control.expertise.copy",
    expertise: {
      eyebrow: "Our expertise",
      title: "We are your traffic management partner",
      copy:
        "Our approach to traffic control combines elite planning with hands-on execution. From parades and event routes to parking lot management and road closures, we coordinate vehicles, pedestrians, and emergency access safely and efficiently.",
    },
    tBlock1Title: "services.traffic-control.blocks.1.title",
    tBlock1Copy:  "services.traffic-control.blocks.1.copy",
    tBlock2Title: "services.traffic-control.blocks.2.title",
    tBlock2Copy:  "services.traffic-control.blocks.2.copy",
    tBlock3Title: "services.traffic-control.blocks.3.title",
    tBlock3Copy:  "services.traffic-control.blocks.3.copy",
    blocks: [
      {
        title: "Strategic traffic coordination",
        copy:
          "At Vision Sécurité, we provide professional traffic control services for parades, festivals, road closures, parking lots, and major events across Quebec and Ontario. Our team has successfully managed traffic in high-pressure situations, including a parade that drew nearly double the expected attendance, where our strategic planning ensured smooth flow and safety for all participants. With years of experience, we understand the importance of coordinating vehicles, pedestrians, and emergency access without disruption.",
        image: traffic_pic1,
        imageAlt: "Security agent directing traffic flow",
      },
      {
        title: "Collaboration with authorities",
        accent: "coordination",
        copy:
          "Our approach to traffic management combines elite strategies and hands-on expertise. We deploy barriers, deterrent mechanisms, and signage to create clear routes and exit points while minimizing congestion and risk. Each plan is tailored to the unique needs of the event, with our logistics team working closely with organizers, municipalities, and law enforcement to guarantee seamless operations. From event traffic management and directing vehicles in crowded parking lots to ensuring pedestrian safety during road closures and parades, Vision Sécurité delivers precision and peace of mind.",
        image: traffic_pic2,
        imageAlt: "Traffic control officers coordinating with law enforcement",
        flip: true,
      },
      {
        title: "Technology-driven visibility & rapid response",
        copy:
          "Technology plays a key role in elevating our traffic control services. Using geo-mapping and live agent tracking, we maintain full visibility of our teams in real time, allowing us to reposition personnel instantly if unexpected issues arise. Our centralized reporting system ensures organizers have direct communication with agents and management 24/7, while our emergency response platform can quickly deploy the nearest available guard to critical areas. This integration of logistics expertise, specialized equipment, and advanced technology makes Vision Sécurité the trusted partner for safe, efficient, and professional traffic control.",
        image: traffic_pic3,
        imageAlt: "Control center monitoring traffic operations",
      },
    ],
    tFooterTitle: "services.traffic-control.footerCta.title",
    tFooterCopy:  "services.traffic-control.footerCta.copy",
    tFooterLabel: "services.traffic-control.footerCta.label",
    footerCta: {
      title: "Ready to optimize your next event’s traffic flow",
      accent: "traffic",
      copy:
        "Let’s plan routes, staffing, and safety procedures tailored to your event and location.",
      label: "Schedule a consultation",
      href: "/contact",
    },
  },

  // ========================= FIRE =========================
  "fire-surveillance": {
    slug: "fire-surveillance",
    tHeroTitle0: "services.fire-surveillance.hero.title0",
    tHeroKicker: "services.fire-surveillance.hero.kicker",
    tHeroCta:    "services.fire-surveillance.hero.cta",
    hero: {
      bgImage: firehousePic,
      titleLines: [{ text: "Fire Surveillance Services", accent: "Services" }],
      kicker: "Businesses • Residences • Construction sites • Events",
     
    },
    tExpEyebrow: "services.fire-surveillance.expertise.eyebrow",
    tExpTitle:   "services.fire-surveillance.expertise.title",
    tExpCopy:    "services.fire-surveillance.expertise.copy",
    expertise: {
      eyebrow: "Our expertise",
      title: "We are your fire safety partner",
      copy:
        "Our agents are trained to detect hazards, monitor high-risk areas, and act immediately when necessary. Whether in warehouses, residential complexes, or event venues, we provide customized surveillance solutions that ensure compliance and protection.",
    },
    tBlock1Title: "services.fire-surveillance.blocks.1.title",
    tBlock1Copy:  "services.fire-surveillance.blocks.1.copy",
    tBlock2Title: "services.fire-surveillance.blocks.2.title",
    tBlock2Copy:  "services.fire-surveillance.blocks.2.copy",
    tBlock3Title: "services.fire-surveillance.blocks.3.title",
    tBlock3Copy:  "services.fire-surveillance.blocks.3.copy",
    blocks: [
      {
        title: "Proactive fire prevention & monitoring",
        copy:
          "At Vision Sécurité, we take fire surveillance and fire prevention seriously. Having worked alongside local fire departments, we understand the critical importance of early detection and proactive safety measures. By embedding strict fire safety protocols into our in-house employee manual, we ensure that every agent is fully equipped to handle potential fire risks, respond to emergencies, and protect lives and property. Our dedication to prevention and quick action makes us a trusted partner for businesses, residential complexes, and event organizers seeking reliable fire safety solutions.",
        image: fire_pic1,
        imageAlt: "Security agent conducting fire safety inspection",
      },
      {
        title: "Regulatory compliance & professional response",
        accent: "compliance",
        copy:
          "Our agents receive specialized fire surveillance training, preparing them to identify hazards, monitor high-risk areas, and take immediate action when necessary. From routine patrols in warehouses and construction sites to overseeing fire watch duties in commercial or residential buildings, we provide flexible solutions tailored to each client’s environment. Our services are fully aligned with Quebec fire codes and building safety regulations, ensuring not only protection but also compliance with provincial standards. With visible deterrence measures—uniformed guards, marked vehicles, and strategic patrol routes—we reinforce safety while giving clients confidence that they are meeting regulatory requirements.",
        image: fire_pic2,
        imageAlt: "Fire surveillance officer ensuring building safety",
        flip: true,
      },
      {
        title: "Technology-powered accountability & rapid action",
        copy:
          "Technology enhances our fire surveillance services by providing real-time accountability and rapid response. With geo-mapping and live agent tracking, we know exactly where our guards are and can redirect resources instantly in the event of an incident. Clients have access to centralized reporting systems, live updates, and 24/7 communication with our management team, ensuring full transparency. In urgent situations, our in-house software identifies the nearest available guard, allowing us to deploy support within an average emergency response time of under 60 minutes. To learn more about our expertise in this field, see our feature on one of our greatest achievements in fire safety",
        image: dsc1622Pic,
        imageAlt: "Control room monitoring fire safety operations",
      },
    ],
    tFooterTitle: "services.fire-surveillance.footerCta.title",
    tFooterCopy:  "services.fire-surveillance.footerCta.copy",
    tFooterLabel: "services.fire-surveillance.footerCta.label",
    footerCta: {
      title: "Ready to enhance your fire safety strategy",
      accent: "safety",
      copy:
        "Discover how Vision Sécurité combines professional training, visible deterrence, and advanced technology to deliver unmatched fire surveillance protection.",
      label: "Schedule a consultation",
      href: "/contact",
    },
  },

  // ========================= HOSPITALITY =========================
  "hospitality-services": {
    slug: "hospitality-services",
    tHeroTitle0: "services.hospitality-services.hero.title0",
    tHeroKicker: "services.hospitality-services.hero.kicker",
    tHeroCta:    "services.hospitality-services.hero.cta",
    hero: {
      bgImage: hospitalityPic,
      titleLines: [{ text: "Hospitality & Concierge Services", accent: "Services" }],
      kicker: "Hotels • Events • Residences • Corporate venues",
    
    },
    tExpEyebrow: "services.hospitality-services.expertise.eyebrow",
    tExpTitle:   "services.hospitality-services.expertise.title",
    tExpCopy:    "services.hospitality-services.expertise.copy",
    expertise: {
      eyebrow: "Our expertise",
      title: "We are your hospitality partner",
      copy:
        "At Vision, we believe that hospitality is more than a service—it’s an experience. Our professional staffing and concierge teams ensure comfort, safety, and satisfaction for every guest, adapting seamlessly to your environment and brand.",
    },
    tBlock1Title: "services.hospitality-services.blocks.1.title",
    tBlock1Copy:  "services.hospitality-services.blocks.1.copy",
    tBlock2Title: "services.hospitality-services.blocks.2.title",
    tBlock2Copy:  "services.hospitality-services.blocks.2.copy",
    tBlock3Title: "services.hospitality-services.blocks.3.title",
    tBlock3Copy:  "services.hospitality-services.blocks.3.copy",
    blocks: [
      {
        title: "Exceptional guest experience",
        copy:
          "Our hospitality professionals are selected and trained to deliver the highest standards of service. Through our in-house customer service training program, every staff member is equipped with the skills to handle demanding environments with professionalism, discretion, and courtesy. Whether it's greeting guests, managing concierge requests, coordinating logistics, or supporting event operations, our team is prepared to create a welcoming and reliable experience for every client and visitor.",
        image: img6026Pic,
        imageAlt: "Concierge greeting guests at luxury venue",
      },
      {
        title: "Professional staffing & coordination",
        accent: "coordination",
        copy:
          "We provide trained staff for corporate events, residential complexes, and high-end functions. Whether coordinating logistics or managing front-of-house operations, our team adapts smoothly to each client's needs.",
        image: pic10,
        imageAlt: "Hospitality staff managing event coordination",
        flip: true,
      },
      {
        title: "Technology-enhanced operations",
        copy:
          "Using centralized scheduling, geo-tracking, and live reporting systems, we ensure the right people are in the right place at the right time. Clients benefit from full transparency, 24/7 management support, and real-time communication.",
        image: theLintonPic,
        imageAlt: "Control center tracking hospitality staff in real time",
      },
    ],
    tFooterTitle: "services.hospitality-services.footerCta.title",
    tFooterCopy:  "services.hospitality-services.footerCta.copy",
    tFooterLabel: "services.hospitality-services.footerCta.label",
    footerCta: {
      title: "Ready to elevate your guest experience",
      accent: "hospitality",
      copy:
        "Discover how Vision Sécurité blends human excellence with innovative systems to deliver unmatched hospitality and concierge services.",
      label: "Schedule a consultation",
      href: "/contact",
    },
  },

  // ========================= LUXURY =========================
  "luxury-security": {
    slug: "luxury-security",
    tHeroTitle0: "services.luxury-security.hero.title0",
    tHeroKicker: "services.luxury-security.hero.kicker",
    tHeroCta:    "services.luxury-security.hero.cta",
    hero: {
      bgVideoSources: [
        { src: luxurySecurityVideoWebm, type: "video/webm" },
        { src: luxurySecurityVideoMp4, type: "video/mp4" }
      ],
      titleLines: [{ text: "Luxury Security Services", accent: "Services" }],
      kicker: "Luxury venues • Private residences • VIP events • Corporate functions",
      cta: { label: "Talk to an expert", href: "/contact" },
    },
    tExpEyebrow: "services.luxury-security.expertise.eyebrow",
    tExpTitle:   "services.luxury-security.expertise.title",
    tExpCopy:    "services.luxury-security.expertise.copy",
    expertise: {
      eyebrow: "Our expertise",
      title: "We are your luxury security partner",
      copy:
        "Our agents embody the highest standards of the industry to ensure security blends seamlessly into luxury settings without compromising effectiveness. Outfitted in black suits and ties—or tailored uniforms to match your brand—they deliver sophistication with full operational readiness, discretion, and respect.",
    },
    tBlock1Title: "services.luxury-security.blocks.1.title",
    tBlock1Copy:  "services.luxury-security.blocks.1.copy",
    tBlock2Title: "services.luxury-security.blocks.2.title",
    tBlock2Copy:  "services.luxury-security.blocks.2.copy",
    tBlock3Title: "services.luxury-security.blocks.3.title",
    tBlock3Copy:  "services.luxury-security.blocks.3.copy",
    blocks: [
      {
        title: "Discreet presence & guest experience",
        copy:
          "At Vision Sécurité, we understand that certain environments demand more than just protection—they require security with elegance and discretion. Our luxury security services are designed for high-end establishments, private residences, VIP events, and corporate functions where presence, professionalism, and appearance are as important as safety itself. Our agents embody the highest standards of the industry, ensuring that security blends seamlessly into luxury settings without ever compromising effectiveness.",
        image: luxury_pic1,
        imageAlt: "Discreet security presence in a luxury setting",
      },
      {
        title: "Tailored deployment & professional image",
        accent: "discretion",
        copy:
          "Our luxury-oriented security agents are trained to adapt to prestigious environments where image matters. Outfitted in black suits and ties—or tailored uniforms to match client requirements—they bring sophistication while maintaining full readiness. These deployments can be more challenging, as discretion and respect are essential in settings where privacy and reputation are paramount. Our team rises to the occasion, combining advanced security expertise with the refined customer service skills necessary to uphold both safety and prestige.",
        image: luxury_pic2,
        imageAlt: "Agent in formal attire providing VIP security",
        flip: true,
      },
      {
        title: "Technology-enabled accountability & rapid response",
        copy:
          "Behind the polished appearance, we support our luxury security services with advanced technology and rapid response systems. Using geo-mapping and live agent tracking, we ensure accountability and seamless deployment. Centralized reporting and 24/7 communication give clients constant peace of mind, while our emergency response platform allows us to dispatch the nearest available agent in under 60 minutes if required. This integration of sophistication, professionalism, and technology ensures that Vision Security delivers security solutions worthy of the most exclusive environments.",
        image: luxury_pic3,
        imageAlt: "Operations center coordinating luxury security in real time",
      },
    ],
    tFooterTitle: "services.luxury-security.footerCta.title",
    tFooterCopy:  "services.luxury-security.footerCta.copy",
    tFooterLabel: "services.luxury-security.footerCta.label",
    footerCta: {
      title: "Ready to elevate your luxury security",
      accent: "luxury",
      copy:
        "Discover how sophistication, professionalism, and advanced technology come together to protect your most exclusive environments.",
      label: "Schedule a consultation",
      href: "/contact",
    },
  },

  // ========================= LOSS PREVENTION =========================
  "loss-prevention": {
    slug: "loss-prevention",
    tHeroTitle0: "services.loss-prevention.hero.title0",
    tHeroKicker: "services.loss-prevention.hero.kicker",
    tHeroCta:    "services.loss-prevention.hero.cta",
    hero: {
      bgImage: mallPic,
      titleLines: [{ text: "Loss Prevention Services", accent: "Services" }],
      kicker: "Retail • Warehouses • Shopping centers • Corporate sites",
      cta: { label: "Talk to an expert", href: "/contact" },
    },
    tExpEyebrow: "services.loss-prevention.expertise.eyebrow",
    tExpTitle:   "services.loss-prevention.expertise.title",
    tExpCopy:    "services.loss-prevention.expertise.copy",
    expertise: {
      eyebrow: "Our expertise",
      title: "We are your loss prevention partner",
      copy:
        "Our approach goes beyond observation. From bag checks and receipt verification to undercover surveillance, we tailor programs that deter theft, document incidents with undeniable proof, and protect your operations end to end.",
    },
    tBlock1Title: "services.loss-prevention.blocks.1.title",
    tBlock1Copy:  "services.loss-prevention.blocks.1.copy",
    tBlock2Title: "services.loss-prevention.blocks.2.title",
    tBlock2Copy:  "services.loss-prevention.blocks.2.copy",
    tBlock3Title: "services.loss-prevention.blocks.3.title",
    tBlock3Copy:  "services.loss-prevention.blocks.3.copy",
    blocks: [
      {
        title: "Proactive in-store controls",
        copy:
          "At Vision Sécurité, we know that loss prevention is critical to protecting your business against theft and reducing financial losses. Retailers and businesses across Quebec and Ontario trust our specialized agents to safeguard their operations and prevent shrinkage before it impacts their bottom line. With proven strategies that have saved clients thousands of dollars, we provide professional, discreet, and effective loss prevention and retail security services that help businesses stay profitable and secure.",
        image: loss_pic1,
        imageAlt: "Loss prevention agent verifying receipts at store exit",
      },
      {
        title: "Undercover operations & intelligence",
        accent: "undercover",
        copy:
          "Our approach to loss prevention goes beyond basic observation. Our agents are trained to perform comprehensive security measures, including bag checks, receipt verification, and undercover surveillance. We also deploy specialized personnel capable of blending seamlessly into retail environments, gathering intelligence, and detecting suspicious activity before it escalates. Every measure we take is designed to deter theft, document incidents, and provide undeniable proof, ensuring that offenders are held accountable and businesses are protected.",
        image: loss_pic2,
        imageAlt: "Plainclothes agent monitoring retail activity",
        flip: true,
      },
      {
        title: "Tech-enabled evidence & rapid response",
        copy:
          "Technology strengthens our efforts in this critical field. By equipping agents with hidden body cameras, live tracking, and centralized reporting systems, we guarantee transparency, evidence collection, and rapid response. Business owners can access real-time updates, communicate directly with our management team, and review documented proof of incidents. This seamless integration of undercover strategies, visible deterrence, and advanced technology makes Vision Sécurité the trusted partner for loss prevention and retail security services across stores, warehouses, and corporate environments.",
        image: loss_pic3,
        imageAlt: "Control dashboard showing real-time incident reporting",
      },
    ],
    tFooterTitle: "services.loss-prevention.footerCta.title",
    tFooterCopy:  "services.loss-prevention.footerCta.copy",
    tFooterLabel: "services.loss-prevention.footerCta.label",
    footerCta: {
      title: "Ready to reduce shrinkage and protect profits",
      accent: "security",
      copy:
        "Let’s design a loss prevention program—visible and undercover—that fits your stores, policies, and risk profile.",
      label: "Schedule a consultation",
      href: "/contact",
    },
  },

  // ========================= INTERVENTION =========================
  "intervention-services": {
    slug: "intervention-services",
    tHeroTitle0: "services.intervention-services.hero.title0",
    tHeroKicker: "services.intervention-services.hero.kicker",
    tHeroCta:    "services.intervention-services.hero.cta",
    hero: {
      bgImage: dsc01103Pic,
      imagePosition: "50% 20%",
      titleLines: [{ text: "Intervention Agents", accent: "Agents" }],
      kicker: "High-risk environments • Crisis response • Specialized operations",
      cta: { label: "Talk to an expert", href: "/contact" },
    },
    carouselImages: [
      carousel1, carousel2, carousel3, carousel4, carousel5, carousel6,
      carousel7, carousel8, carousel9, carousel10, carousel11, carousel12,
      carousel13, carousel14, carousel15, carousel16, carousel17, carousel18,
      carousel19, carousel20, carousel21, carousel22, carousel23, carousel24
    ],
    tExpEyebrow: "services.intervention-services.expertise.eyebrow",
    tExpTitle:   "services.intervention-services.expertise.title",
    tExpCopy:    "services.intervention-services.expertise.copy",
    expertise: {
      eyebrow: "Our expertise",
      title: "Elite intervention agents",
      copy:
        "Becoming a Vision intervention officer is a privilege reserved for only the most qualified candidates. Our team is primarily composed of physically fit, well-spoken military veterans and intervention specialists who possess both the physical readiness and the communication skills required for demanding environments. These agents are not just a visible presence—they are trusted problem solvers, capable of de-escalating tense situations or taking decisive action when needed. Their background and training make them uniquely equipped to handle challenges that go beyond conventional security requirements.",
    },
    tBlock1Title: "services.intervention-services.blocks.1.title",
    tBlock1Copy:  "services.intervention-services.blocks.1.copy",
    tBlock2Title: "services.intervention-services.blocks.2.title",
    tBlock2Copy:  "services.intervention-services.blocks.2.copy",
    tBlock3Title: "services.intervention-services.blocks.3.title",
    tBlock3Copy:  "services.intervention-services.blocks.3.copy",
    blocks: [
      {
        title: "High-risk operations & crisis management",
        copy:
          "At Vision Sécurité, our intervention agents represent the highest level of security expertise. Unlike standard guards, these specialists are trained and equipped to actively resolve high-risk situations rather than simply deter them. Each member of our intervention team undergoes rigorous in-house training, developed and delivered by our CEO in collaboration with high-ranking members of the RCMP and the Canadian Armed Forces. This elite preparation ensures that when a critical incident arises, our intervention officers respond with precision, discipline, and professionalism",
        image: intervention_pic1,
        imageAlt: "Intervention agents managing a high-risk environment",
      },
      {
        title: "Military-grade training & rapid deployment",
        accent: "precision",
        copy:
          "Becoming a Vision intervention officer is a privilege reserved for only the most qualified candidates. Our team is primarily composed of physically fit, well-spoken military veterans and intervention specialists who possess both the physical readiness and the communication skills required for demanding environments. These agents are not just a visible presence—they are trusted problem solvers, capable of de-escalating tense situations or taking decisive action when needed. Their background and training make them uniquely equipped to handle challenges that go beyond conventional security requirements.",
        image: intervention_pic2,
        imageAlt: "Highly trained intervention agents in action",
        flip: true,
      },
      {
        title: "Excellence through discipline & leadership",
        copy:
          "Our intervention services are particularly valuable for high-risk clients and environments, including large-scale events, eviction services, labor disputes, construction sites, and any location prone to conflict or escalation. Technology strengthens our capabilities through geo-mapping, live agent tracking, and centralized reporting systems, giving us full visibility and rapid deployment options. In urgent cases, our emergency response platform identifies the nearest intervention agent, guaranteeing swift action. This powerful combination of advanced training, military discipline, and cutting-edge technology makes Vision Sécurité the leading choice for specialized intervention. To see one of our greatest accomplishments in this field",
        image: intervention_pic3,
        imageAlt: "Vision Sécurité intervention team demonstrating leadership",
      },
    ],
    tFooterTitle: "services.intervention-services.footerCta.title",
    tFooterCopy:  "services.intervention-services.footerCta.copy",
    tFooterLabel: "services.intervention-services.footerCta.label",
    footerCta: {
      title: "Ready to deploy specialized intervention",
      accent: "intervention",
      copy:
        "To see one of our greatest accomplishments in this field.",
      label: "Schedule a consultation",
      href: "/contact",
    },
  },

  // ========================= CONSTRUCTION =========================
  "construction-site-services": {
    slug: "construction-site-services",
    tHeroTitle0: "services.construction-site-services.hero.title0",
    tHeroKicker: "services.construction-site-services.hero.kicker",
    tHeroCta:    "services.construction-site-services.hero.cta",
    hero: {
      bgImage: constructionHeroPic,
      titleLines: [{ text: "Construction Site Security", accent: "Security" }],
      kicker: "Perimeter control • Asset protection • 24/7 guard & monitoring",
      cta: { label: "Talk to an expert", href: "/contact" },
    },
    tExpEyebrow: "services.construction-site-services.expertise.eyebrow",
    tExpTitle:   "services.construction-site-services.expertise.title",
    tExpCopy:    "services.construction-site-services.expertise.copy",
    expertise: {
      eyebrow: "Our expertise",
      title: "End-to-end construction site protection",
      copy:
        "From greenfield to handover, we combine trained site guards, mobile patrols, and camera towers to protect equipment, copper, fuel, and materials. We enforce sign-in/badging, lockout/tagout, hot-works watch, and CNESST/OHSA-aligned protocols. Daily logs, photo evidence, and digital reports keep GCs and owners fully informed.",
    },
    tBlock1Title: "services.construction-site-services.blocks.1.title",
    tBlock1Copy:  "services.construction-site-services.blocks.1.copy",
    tBlock2Title: "services.construction-site-services.blocks.2.title",
    tBlock2Copy:  "services.construction-site-services.blocks.2.copy",
    tBlock3Title: "services.construction-site-services.blocks.3.title",
    tBlock3Copy:  "services.construction-site-services.blocks.3.copy",
    blocks: [
      {
        title: "Access control, perimeter & asset security",
        copy:
          "We staff gates, verify subcontractors, manage visitor passes, and coordinate deliveries. Guards perform perimeter checks, secure laydown yards, and deter fuel and copper theft. Geo-tagged patrols and seal checks (containers, tool cribs) create a defensible chain of custody.",
        image: construction_pic1,
        imageAlt: "Guard verifying contractor access at a controlled site gate",
      },
      {
        title: "After-hours patrols & rapid response",
        accent: "readiness",
        copy:
          "Night and weekend patrols with randomized routes, light/noise discipline, and alarm response reduce losses when sites are most vulnerable. Our dispatch tracks live guard locations and dispatches mobile units or law enforcement as needed for trespassers, encampments, or break-ins.",
        image: construction_pic2,
        imageAlt: "Mobile patrol conducting after-hours perimeter sweep",
        flip: true,
      },
      {
        title: "Safety compliance & digital reporting",
        copy:
          "We support toolbox talks, lone-worker checks, confined-space watch, and hot-works fire watch. Every shift produces time-stamped digital reports with photos, incidents, and corrective actions—exportable for client audits and insurer requirements.",
        image: dsc01642Pic,
        imageAlt: "Digital incident report compiled for a construction project",
      },
    ],
    tFooterTitle: "services.construction-site-services.footerCta.title",
    tFooterCopy:  "services.construction-site-services.footerCta.copy",
    tFooterLabel: "services.construction-site-services.footerCta.label",
    footerCta: {
      title: "Ready to secure your construction site",
      accent: "secure",
      copy:
        "See how we reduced theft incidents by 80% and improved delivery throughput on a multi-tower project—case study available on request.",
      label: "Schedule a consultation",
      href: "/contact",
    },
  },

  // ========================= PATROL =========================
  "patrol-services": {
    slug: "patrol-services",
    tHeroTitle0: "services.patrol-services.hero.title0",
    tHeroKicker: "services.patrol-services.hero.kicker",
    tHeroCta:    "services.patrol-services.hero.cta",
    hero: {
      bgImage: patrolServicesPic,
      titleLines: [{ text: "Patrol Services", accent: "Services" }],
      kicker: "Commercial • Residential • Construction • Industrial",
      cta: { label: "Talk to an expert", href: "/contact" },
    },
    tExpEyebrow: "services.patrol-services.expertise.eyebrow",
    tExpTitle:   "services.patrol-services.expertise.title",
    tExpCopy:    "services.patrol-services.expertise.copy",
    expertise: {
      eyebrow: "Our expertise",
      title: "Smart, adaptable patrol coverage",
      copy:
        "For clients managing multiple locations, our team specializes in multi-property patrol solutions. We strategically design and optimize patrol routes to save both time and money, ensuring maximum coverage while maintaining efficiency. This flexibility allows us to adapt patrol schedules based on crime trends, seasonal risks, or client requests. With visible deterrence, professional agents, and flexible coverage, Vision Sécurité delivers patrol services that are both cost-effective and highly reliable.",
    },
    tBlock1Title: "services.patrol-services.blocks.1.title",
    tBlock1Copy:  "services.patrol-services.blocks.1.copy",
    tBlock2Title: "services.patrol-services.blocks.2.title",
    tBlock2Copy:  "services.patrol-services.blocks.2.copy",
    tBlock3Title: "services.patrol-services.blocks.3.title",
    tBlock3Copy:  "services.patrol-services.blocks.3.copy",
    blocks: [
      {
        title: "Visible deterrence & discreet intervention",
        copy:
          "Using marked vehicles to deter crime and unmarked vehicles to discreetly stop it, our patrol model delivers an adaptable presence for trespassing, vandalism, and theft prevention—tailored to your site's unique risks.",
        image: silverUnmarkedPic,
        imageAlt: "Marked and unmarked patrol vehicles providing coverage",
      },
      {
        title: "Multi-property route optimization",
        accent: "efficiency",
        copy:
          "We design and refine patrol routes across multiple sites to maximize coverage and reduce costs—adjusting schedules based on crime trends, seasonal risks, and evolving client requirements.",
        image: patrolBlock2Pic,
        imageAlt: "Route planning and scheduling for multiple properties",
        flip: true,
      },
      {
        title: "Live tracking, reporting & data-driven improvements",
        copy:
          "Technology is at the core of our patrol strategy. Through geo-mapping, live agent tracking, and centralized reporting, clients access live reports, incident documentation, and 24/7 communication. Over time, patrol data helps refine routes, identify patterns, and strengthen deterrence across Quebec and Ontario.",
        image: patrolBlock3Pic,
        imageAlt: "Operations center with live patrol tracking and reports",
      },
    ],
    tFooterTitle: "services.patrol-services.footerCta.title",
    tFooterCopy:  "services.patrol-services.footerCta.copy",
    tFooterLabel: "services.patrol-services.footerCta.label",
    footerCta: {
      title: "Ready to optimize your patrol coverage",
      accent: "patrol",
      copy:
        "Combine visible patrols, adaptive strategies, and advanced technology for reliable, cost-effective protection across all your properties.",
      label: "Schedule a consultation",
      href: "/contact",
    },
  },

  // ========================= VIP =========================
  "VIP-security-services": {
    slug: "VIP-security-services",
    tHeroTitle0: "services.VIP-security-services.hero.title0",
    tHeroKicker: "services.VIP-security-services.hero.kicker",
    tHeroCta:    "services.VIP-security-services.hero.cta",
    hero: {
      bgImage: vipPic,
      titleLines: [{ text: "VIP Security Services", accent: "Services" }],
      kicker: "Executive protection • Close protection • High-profile clients",
      cta: { label: "Talk to an expert", href: "/contact" },
    },
    carouselImages: [
      carousel1, carousel2, carousel3, carousel4, carousel5, carousel6,
      carousel7, carousel8, carousel9, carousel10, carousel11, carousel12,
      carousel13, carousel14, carousel15, carousel16, carousel17, carousel18,
      carousel19, carousel20, carousel21, carousel22, carousel23, carousel24
    ],
    tExpEyebrow: "services.VIP-security-services.expertise.eyebrow",
    tExpTitle:   "services.VIP-security-services.expertise.title",
    tExpCopy:    "services.VIP-security-services.expertise.copy",
    expertise: {
      eyebrow: "Our expertise",
      title: "Elite VIP protection specialists",
      copy:
        "Our bodyguarding team is second to none, composed of seasoned military veterans, specialized security professionals, and individuals carefully selected for their strength, discipline, and discretion. Close protection requires more than size—it demands intelligence, anticipation, and precision. For that reason, very few applicants are accepted into our VIP protection unit. Each member undergoes rigorous training in executive protection, close-quarters defense, threat assessment, and emergency response, ensuring that our clients receive only the best in personal security.",
    },
    tBlock1Title: "services.VIP-security-services.blocks.1.title",
    tBlock1Copy:  "services.VIP-security-services.blocks.1.copy",
    tBlock2Title: "services.VIP-security-services.blocks.2.title",
    tBlock2Copy:  "services.VIP-security-services.blocks.2.copy",
    tBlock3Title: "services.VIP-security-services.blocks.3.title",
    tBlock3Copy:  "services.VIP-security-services.blocks.3.copy",
    blocks: [
      {
        title: "Discreet executive & celebrity protection",
        copy:
          "At Vision, we provide elite VIP security, executive protection, and close protection services for high-profile individuals across Quebec, Ontario, and beyond. Our experience includes safeguarding politicians, CEOs, religious leaders, and world-renowned celebrities—always with the highest level of professionalism and confidentiality. While discretion prevents us from naming many of our distinguished clients, our portfolio includes international artists such as Rae Sremmurd, Damso, Swae Lee, Slim Jxmmi, YNG Chris, Nettspend, 2Hollis, Xzibit… among others. This proven track record demonstrates our ability to manage complex protection requirements at the highest level.",
        image: damsoPic,
        imageAlt: "VIP protection agents ensuring client safety",
      },
      {
        title: "Advanced technology & real-time oversight",
        accent: "precision",
        copy:
          "Through advanced geo-mapping, live agent tracking, and centralized reporting systems, our management team maintains complete visibility and communication at all times. These tools allow proactive decision-making and rapid adjustments to evolving risks.",
        image: nettspendPic,
        imageAlt: "Security operations team monitoring real-time data",
        flip: true,
      },
      {
        title: "Trusted protection wherever you go",
        copy:
          "Combined with our strong relationships across law enforcement and private networks, we anticipate risks and adapt strategies before our clients even arrive. Whether it's international travel, luxury events, or secure transport, Vision Sécurité guarantees discreet, reliable, and world-class protection.",
        image: hollisPic,
        imageAlt: "Close protection team escorting VIP client",
      },
    ],
    tFooterTitle: "services.VIP-security-services.footerCta.title",
    tFooterCopy:  "services.VIP-security-services.footerCta.copy",
    tFooterLabel: "services.VIP-security-services.footerCta.label",
    footerCta: {
      title: "Ready to secure your next engagement",
      accent: "security",
      copy:
        "Experience peace of mind with Vision Sécurité’s world-class VIP and executive protection services—tailored to your needs, wherever you are.",
      label: "Schedule a consultation",
      href: "/contact",
    },
  },
};

export default SERVICES;
